import React from "react";

interface IDetailsCardProps{
    title: string,
    content: string,
    customClass?: string,
    isBig? : boolean
}

const DetailsCard:React.FC<IDetailsCardProps> = ({title, content, customClass, isBig = false}) => {
    return(
        <div className={`border rounded-xl text-sm flex flex-row justify-between ${customClass ?? null}`}>
            <div className={`py-3 ${isBig ? "w-1/3" : "w-1/2"} rounded-r-xl h-full text-center bg-gray-200`}>{title}</div>
            <div className={`py-3 ${isBig ? "w-2/3" : "w-1/2"} rounded-l-xl text-center h-full bg-white truncate`}>{content}</div>
        </div>
    )
}

export default DetailsCard